export const getOpacityCssClass = (opacity?:number):string|null => {
    return opacity ? `opacity-${opacity.toString().split('.').join('')}` : null
}

export function arrayFlat<U>(arr: U[][]): U[] {
    if ((arr as unknown as U[]).every((val) => !Array.isArray(val))) {
        return (arr as unknown as U[]).slice();
    }
    return arr
        .reduce((acc, val) => acc
            .concat(Array.isArray(val) ? arrayFlat((val as unknown as U[][])) : val), []);
}





// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/renderer/Utils.ts